module.exports = __webpack_public_path__ + "img/pipe2.b2c73aee.png";